import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useSetupHook from './hooks'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import Buttonbar from '../../components/ButtonBar'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
const paymentDetailDetailLinkRender = (text: any, record: any) => {
  return <Link to={`/srm/paymentrequestdetail?id=${record.id}`}>{text}</Link>
}
const PaymentReqauest = () => {
  const {
    state,
    handleTableRefresh,
    handlePaginationChange,
    handleSearchClick,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption } = state
  const columns = [
    {
      key: 'paymentNo',
      dataIndex: 'paymentNo',
      title: '付款单号',
      render: paymentDetailDetailLinkRender,
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{marginLeft:'5px'}}/>
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'paymentStatus',
      dataIndex: 'paymentStatus',
      title: '付款状态',
    },
    {
      key: 'orderCount',
      dataIndex: 'orderCount',
      title: '订单数',
    },
    {
      key: 'applyPrice',
      dataIndex: 'applyPrice',
      title: '申请付款金额',
    },
    {
      key: 'paymentPrice',
      dataIndex: 'paymentPrice',
      title: '已付金额',
    },
    {
      key: 'submitMan',
      dataIndex: 'submitMan',
      title: '提交人',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '提交时间',
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'paymentNo',
          'paymentStatus',
          'orderCount',
          'paymentRequestStartTime',
          'paymentRequestEndTime',
        ]}
        onSearch={handleSearchClick}
        keyName="PAYMENTREQUEST"
        ScreenKey="PAYMENTREQUEST"
      />
      <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
    </div>
  )
}
export default PaymentReqauest
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useSetupHook from './hooks'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import Buttonbar from '../../components/ButtonBar'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
const paymentDetailDetailLinkRender = (text: any, record: any) => {
  return <Link to={`/srm/paymentrequestdetail?id=${record.id}`}>{text}</Link>
}
const PaymentReqauest = () => {
  const {
    state,
    handleTableRefresh,
    handlePaginationChange,
    handleSearchClick,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption } = state
  const columns = [
    {
      key: 'paymentNo',
      dataIndex: 'paymentNo',
      title: '付款单号',
      render: paymentDetailDetailLinkRender,
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{marginLeft:'5px'}}/>
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'paymentStatus',
      dataIndex: 'paymentStatus',
      title: '付款状态',
    },
    {
      key: 'orderCount',
      dataIndex: 'orderCount',
      title: '订单数',
    },
    {
      key: 'applyPrice',
      dataIndex: 'applyPrice',
      title: '申请付款金额',
    },
    {
      key: 'paymentPrice',
      dataIndex: 'paymentPrice',
      title: '已付金额',
    },
    {
      key: 'submitMan',
      dataIndex: 'submitMan',
      title: '提交人',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '提交时间',
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'paymentNo',
          'paymentStatus',
          'orderCount',
          'paymentRequestStartTime',
          'paymentRequestEndTime',
        ]}
        onSearch={handleSearchClick}
        keyName="PAYMENTREQUEST"
        ScreenKey="PAYMENTREQUEST"
      />
      <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
    </div>
  )
}
export default PaymentReqauest
